import { render } from "./WidgetComment.vue?vue&type=template&id=2c4f46cc&ts=true"
import script from "./WidgetComment.vue?vue&type=script&lang=ts"
export * from "./WidgetComment.vue?vue&type=script&lang=ts"

import "./WidgetComment.vue?vue&type=style&index=0&id=2c4f46cc&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__